import { ReactNode } from 'react';

const FeaturePanel = ({ children }: { children: ReactNode }) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 sm:gap-x-8 gap-y-10 sm:gap-y-12 sm:w-1/2'>
      {children}
    </div>
  );
};

export default FeaturePanel;
